import { render, staticRenderFns } from "./desglosetema.vue?vue&type=template&id=4578113d"
import script from "./desglosetema.vue?vue&type=script&lang=js"
export * from "./desglosetema.vue?vue&type=script&lang=js"
import style0 from "./desglosetema.vue?vue&type=style&index=0&id=4578113d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports